// ** React Imports
import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography'
import Icon from 'src/features/common/CustomIcon'
import Link from '@mui/material/Link';
// ** Store Imports
import { SelectOption } from 'src/types/common';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
// ** Custom Components Imports
import Tooltip from '@mui/material/Tooltip'
import { client } from 'src/utils/axios-client'
import { leadEndpoints } from 'src/configs/endpoints'

import _, { now } from 'lodash'
import { ActivityType, CadenceListDialogStore, DashboardViewStore, InboundCall, InboundCallsStore, InboundCallStore, Lead, LeadListStore, LeadScreenStore, QuickLeadDialogStore, ViewType } from '../../stores/LeadStore'
import { ActivityColor, colorDateTooltipOverdue, colorDateTooltipOverdueDashboard, nextDateDays, nextDateDaysDashboard } from '../../utils/date-utils'
import { DataGridPro } from '@mui/x-data-grid-pro/DataGridPro'
import LeadDataFormater from '../leads/view/LeadDataFormater'
import IconButton from '@mui/material/IconButton';
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';
import DateTimeDisplay from '../common/DateTimeDisplay';
import { red } from '@mui/material/colors';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import CheckIcon from '@mui/icons-material/Check';
import { error } from 'console';
import ReactAudioPlayer from 'react-audio-player';
import Button from '@mui/material/Button';
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';
import GridSkeleton from '../common/GridSkeleton';


interface CellType {
    row: InboundCall
}

type Props = {
    userId: string,
}

const InboundCallList = ({ userId}: Props) => {
    const [pageSize, setPageSize] = useState(10000);
    const [value, setValue] = useState<string>('')
    const [reloadRecords, setReloadRecords] = useState<boolean>(false)
    const list = InboundCallsStore.useState(s => s.items);
    const [filteredList, setFilteredList] = useState([] as InboundCall[])
    const showTodoList = DashboardViewStore.useState(s => s.showTodoList);
    const [hasLoaded, setHasLoaded] = useState<boolean>(false)

    const [filtersOpen, setFiltersOpen] = useState(false);

    useEffect(() => {
        setHasLoaded(false);
        loadRecords(userId);
    }, [])

    useEffect(() => {
        if (reloadRecords) {
            setHasLoaded(false);
            loadRecords(userId);
        }
        
    }, [reloadRecords])

    useEffect(() => {
        setFilteredList(list);
    }, [list, value])

    const loadRecords = async (userId: string) => {
        const response = await client.get(leadEndpoints.getinboundcalls, { params: { userId} });
        InboundCallsStore.update(s => { s.items = response.data });
        setHasLoaded(true);
        setReloadRecords(false);
    }

    
    const onExecuteActivity = async (id: string) => {
        const response = await client.get(leadEndpoints.markinboundcallasreviewed, { params: { id } });
        setReloadRecords(true);
    };

    const viewQuickLead = (lead: Lead) => {
        LeadScreenStore.update(s => { s.selectedLead = lead });
        QuickLeadDialogStore.update(s => { s.quickLeadDialogMode = true })
    };
    

    const reload = () => {
        if (reloadRecords) {
            setReloadRecords(false);
        }
        else {
            setReloadRecords(true);
        }
    };

    const goBack = () => {
        DashboardViewStore.update(s => { s.activityDate = '' });
        DashboardViewStore.update(s => { s.showTodoList = true });
        DashboardViewStore.update(s => { s.showActivityWorkList = false });
        DashboardViewStore.update(s => { s.showInboundCallList = false });
        DashboardViewStore.update(s => { s.showDefault = true });
        DashboardViewStore.update(s => { s.showDetail = false });
        DashboardViewStore.update(s => { s.showTaskList = false });
    };

    //const setActionButton = (date: Date) => {
    //    const now = new Date();

    //    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    //    var dayDifference = timeDifference / (1000 * 3600 * 24);

    //    dayDifference = Math.round(dayDifference);

    //    if (dayDifference > 1) {
    //        return true;
    //    }
    //    else if (dayDifference == 1) {
    //        return true;
    //    }
    //    return false;
    //};


    const columns = [
        {
            flex: 0.1,
            minWidth: 100,
            field: 'CallDate',
            headerName: 'Date',
            hideable: false,
            valueGetter: ({ row }: CellType) => row.callDate,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            <Typography variant="caption" sx={{ color: colorDateTooltipOverdueDashboard(row.callDate) }} >{nextDateDaysDashboard(row.callDate)}</Typography>
                        </Box>
                    </Box>
                )
            }
        },
         {
            flex: 1,
            minWidth: 100,
            field: 'Status',
            headerName: 'Status',
            valueGetter: ({ row }: CellType) => row.status,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.status == "voicemail recieved" &&
                                <Typography noWrap variant='body2'>
                                    Voicemail Received
                                </Typography>        
                            }  
                            {row.status == "no-answer" &&
                                <Typography noWrap variant='body2'>
                                    No Answer
                                </Typography>
                            }
                            {row.status == "busy" &&
                                <Typography noWrap variant='body2'>
                                    Busy
                                </Typography>
                            }
                            
                        </Box>
                    </Box>


                )
            }
        },
        {
            flex: 1,
            minWidth: 130,
            field: 'FromNumber',
            headerName: 'From Number',
            valueGetter: ({ row }: CellType) => row.fronNumber,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            <Typography noWrap variant='body2'>
                                {row.fromNumber}
                            </Typography>
                        </Box>
                    </Box>


                )
            }
        },
        {
            flex: 1,
            minWidth: 130,
            field: 'FromState',
            headerName: 'From State',
            valueGetter: ({ row }: CellType) => row.fromState,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.fromState == "" &&
                                < Typography noWrap variant='body2'>
                                    Unknown
                                </Typography>
                            }
                            {row.fromState != "" &&
                                < Typography noWrap variant='body2'>
                                    {row.fromState }
                                </Typography>
                            }
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 130,
            field: 'FromLead',
            headerName: 'Lead',
            valueGetter: ({ row }: CellType) => row.leadName,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.lead == null &&
                                < Typography noWrap variant='body2'>
                                    Unknown
                                </Typography>
                            }
                            {row.lead != null &&
                                <Link
                                    sx={{ color: 'text.primary', textDecoration: 'none' }}
                                    underline="hover"
                                    component="button"
                                    variant="caption"
                                    onClick={() => viewQuickLead(row.lead)}
                                >
                                    {row.leadName}
                                </Link>
                            }
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 2,
            minWidth: 200,
            field: 'Voicemail',
            headerName: 'Voicemail',
            valueGetter: ({ row }: CellType) => row.incomingVMUrl,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.incomingVMUrl == null &&
                                < Typography noWrap variant='body2'>
                                    
                                </Typography>
                            }
                            {row.incomingVMUrl != null &&
                                <ReactAudioPlayer
                                src={row.incomingVMUrl}
                                    controls={true}
                                />
                            }
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 0.3,
            minWidth: 150,
            field: 'Action',
            headerName: 'Action',
            hideable: false,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            <Button variant="outlined" startIcon={<CheckBoxTwoToneIcon />} size="small" onClick={() => onExecuteActivity(row.id)}>
                                Reviewed
                            </Button>
                        </Box>
                    </Box>


                )
            }
        },

    ];

    const handleFilter = useCallback((val: string) => {
        setValue(val)
    }, [])


    if (!hasLoaded) return <GridSkeleton/>;

    return (
        <Card sx={{ width: '100%' }}>
            <Box sx={{ p: 5, pb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ mr: 4, mb: 2 }}>
                    <Tooltip title="Go Back" >
                        <IconButton aria-label="Go Back to Dashboard" onClick={() => goBack()} >
                            <ArrowBackTwoToneIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Box sx={{ mr: 4, mb: 2 }}>
                    <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                        Missed Incoming Calls and Voicemails
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                    <Tooltip title="Refresh" >
                        <IconButton aria-label="Next activity" onClick={() => reload()} >
                            <RefreshTwoToneIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <DataGridPro
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            // Hide columns
                            //JobTitle: false,
                            //EmailAddress: false,
                            //CountryName: false,
                            //IndustryName: false,
                            //Salutation: false,
                            //LeadLevel: false,
                            //DirectPhone: false,
                            //MobilePhone: false,
                            //SwitchboardPhone: false,
                            //LastActivityName: false,
                            //LastActivityDateTime: false,
                            //LastActivityOwner: false,
                            //NextActivityName: false,
                            //NextActivityDateTime: false,
                            //NextActivityOwner: false,
                            //AddressStreet: false,
                            //AddressCity: false,
                            //AddressProvince: false,
                            //AddressPostalCode: false,
                            //LeadFunction: false,
                            //LeadSource: false,
                            //AddressRegion: false,
                            //Fax: false,
                            //Website: false,
                            //Owner: false,
                            //SprintName: false,
                            //AccountRevenue: false,
                            //EmployeeSize: false,
                            //HotLead: false,
                            //MeanigfulInteraction: false
                        },
                    },
                }}
                autoHeight
                pagination={false}
                rows={filteredList}
                columns={columns}
                //pageSize={pageSize}
                disableSelectionOnClick

            //rowsPerPageOptions={[5, 10, 25, 50]}
            //rowCount={list.totalCount}
            //paginationMode="server"
            //onPageChange={(newPage: number) => loadRecords(newPage, pageSize, activityDate, startDate, endDate, userId, activityName)}
            //onPageSizeChange={(newPageSize: number) => setPageSize(newPageSize)}

            />




        </Card>
    )


}

export { InboundCallList }
export default InboundCallList
